import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { POSITION_MODEL } from '../../Helpers/PositionModel';
import CustomTooltip from "../CustomTooltip";

/**
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 * @Description Action sub button component.
 * @param String id: Button identifier (required).
 * @param String name: Name of the model that receives the button (required).
 * @param String className: Style class for the button or default styles (optional).
 * @param String nameClass: Style class for the name(optional).
 * @param Boolean disabled: Variable to disable the button (required).
 * @param event onClick: Click event (required).
 * @param String url: Navigation URL (optional).
 * @param {JSX.Element} Icon: Icon component (optional).
 * @param String iconProps: Two style classes for the icon, one for size and another for color, or default styles initialized
 * @param Object state: Optional state to pass to the next route
 * @param {'right' | 'left'} iconPosition - Determines whether the icon appears before or after the text (optional, default: 'end').
 * @returns {JSX.Element}
 */
const ButtonSubAction = (props) => {
    const {
        id = 'btn_bsa_sub_action',
        name,
        className = 'btn-transparent font-color-text-950',
        disabled = false,
        onClick = null,
        url = '',
        Icon,
        iconProps = 'btn-icon-svg-12px btn-icon-svg-black',
        state = null,
        iconPosition = POSITION_MODEL.RIGHT,
        nameClass,
    } = props;

    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <button
            id={id}
            className={`btn-href-icon-svg ${className}`}
            disabled={disabled}
            onClick={(e) => {
                if (onClick !== null) onClick(e);

                if (url !== '') {
                    if (state !== null && state !== undefined) {
                        navigate(url, { state });
                    } else {
                        navigate(url);
                    }
                }
            }}
        >
            {Icon && iconPosition === POSITION_MODEL.RIGHT && (
                <Icon className={`mr-2 ${iconProps}`} />
            )}
            <CustomTooltip
                text={t(name)}
                classes={`${nameClass}`}
                showIfTruncated={true}
            />
            {Icon && iconPosition === POSITION_MODEL.LEFT && (
                <Icon className={`ml-2 ${iconProps}`} />
            )}
        </button>
    );
};

export default ButtonSubAction;
